import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable()
export class ExelService {

  constructor() { }
  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, ExelService.toExportFileName(excelFileName));
  }

  /**
   * Client-side CSV export of the provided rows. Reuses the same xlsx lib (sheet_to_csv) as the
   * XLS path so no extra dependency is introduced. The exported file is generated from the
   * supplied query-result rows (no server-side report file).
   */
  public exportAsCsvFile(json: any[], csvFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const csv: string = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${csvFileName}_export_${new Date().getTime()}.csv`;
    // Attach to the DOM before clicking and revoke asynchronously — some browsers (Firefox)
    // ignore a click on a detached link or cancel the download if the URL is revoked too soon.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
  }
}
